import { useEffect, useState } from "react";
import { Loader2, ShieldAlert, Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";

export function FullScreenLoader({ error, onRetry, onLogin }) {
  const [slow, setSlow] = useState(false);
  useEffect(() => { const t = setTimeout(() => setSlow(true), 8000); return () => clearTimeout(t); }, []);
  return (
    <div className="h-screen grid place-items-center bg-slate-50 px-6" data-testid="app-loader">
      {error ? (
        <div className="text-center max-w-sm" data-testid="app-boot-error">
          <p className="text-sm text-slate-700 mb-4">{error}</p>
          <div className="flex gap-2 justify-center">
            <Button onClick={onRetry} data-testid="app-boot-retry">Tekrar dene</Button>
            <Button variant="outline" onClick={onLogin} data-testid="app-boot-login">Giriş ekranına dön</Button>
          </div>
        </div>
      ) : (
        <div className="text-center">
          <Loader2 className="h-6 w-6 animate-spin text-blue-600 mx-auto" />
          {slow && <p className="text-xs text-slate-500 mt-3" data-testid="app-loader-slow">Bağlantı yavaş, bekleniyor…
            <button className="ml-1 underline" onClick={() => window.location.reload()} data-testid="app-loader-reload">Sayfayı yenile</button></p>}
        </div>
      )}
    </div>
  );
}

export const Forbidden = () => (
  <div className="p-10 fade-up" data-testid="forbidden-page">
    <div className="panel max-w-xl p-8">
      <ShieldAlert className="h-8 w-8 text-rose-600 mb-4" />
      <h1 className="text-2xl font-bold text-slate-900">Bu sayfaya erişim yetkiniz yok</h1>
      <p className="text-sm text-slate-500 mt-2">Rolünüz bu modülü görüntüleme yetkisine sahip değil. Yetki talebi için sistem yöneticinize başvurun.</p>
    </div>
  </div>
);

export const EmptyRow = ({ cols, text = "Kayıt bulunamadı" }) => (
  <tr><td colSpan={cols} className="!py-10 text-center text-slate-400"><Inbox className="h-5 w-5 mx-auto mb-2" />{text}</td></tr>
);

export const LoadingRow = ({ cols }) => (
  <tr><td colSpan={cols} className="!py-10 text-center"><Loader2 className="h-5 w-5 animate-spin mx-auto text-blue-600" /></td></tr>
);

export function Pager({ page, pageSize, total, onPage, testid = "pager" }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total ? (page - 1) * pageSize + 1 : 0;
  const to = Math.min(total, page * pageSize);
  return (
    <div className="flex items-center justify-between px-3 py-2 border-t border-slate-200 text-xs text-slate-500" data-testid={testid}>
      <span data-testid={`${testid}-info`}>{from}–{to} / {total} kayıt</span>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" className="h-7" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`${testid}-prev`}>Önceki</Button>
        <span className="font-mono">{page}/{pages}</span>
        <Button variant="outline" size="sm" className="h-7" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid={`${testid}-next`}>Sonraki</Button>
      </div>
    </div>
  );
}

export const PageHeader = ({ title, subtitle, children, testid }) => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-5 fade-up">
    <div>
      <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-slate-900" data-testid={testid}>{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);
